import styles from "./mirrored-permissions-card.module.scss";
import { concatAddress } from "@/utils/concat-address";
import { type Permission } from "@/types/modular-permissions.types";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import resolveChainName from "@/utils/resolve-chain-name";
import resolveProtocol from "@/utils/resolve-protocol";
import PersonSVG from "@/features/mod-perms/components/cards/permissions-card/person-svg";
import Tag from "@/features/mod-perms/components/cards/permissions-card/tag/tag";

type Props = {
  delegate: Permission;
  isPlaceholder?: boolean;
};

const MirroredPermissionsCard = ({
  delegate,
  isPlaceholder = false,
}: Props) => {
  const { isDelegateContextGranted } = useModularPermissionsStore();

  const displayAddress = isDelegateContextGranted()
    ? delegate.delegate
    : delegate.vault;

  return (
    <div className={styles.mirroredCard}>
      <div className={styles.profileImage}>
        <PersonSVG />
      </div>
      <div className={styles.desktopContent}>
        <div className={styles.left}>
          <span className={styles.walletAddress}>
            {concatAddress(displayAddress)}
          </span>
          <p>
            Permissions: <b>all</b>
          </p>
        </div>
        <div className={styles.right}>
          <p>
            Source: <b>{resolveChainName(delegate.chain)}</b>
          </p>
          <p>
            Protocol: <b>{resolveProtocol(delegate.source)}</b>
          </p>
        </div>
      </div>
      <div className={styles.mobileContent}>
        <div className={styles.top}>
          <span className={styles.walletAddress}>
            {concatAddress(displayAddress)}
          </span>

          <p>
            <b>{resolveChainName(delegate.chain)}</b>
          </p>
          <p>
            <b>{resolveProtocol(delegate.source)}</b>
          </p>
        </div>
        <div className={styles.bottom}>
          <Tag
            indicatorValue="All"
            title="Permissions selected"
            color="grey"
            noContainer
          />
        </div>
      </div>
    </div>
  );
};

export default MirroredPermissionsCard;
